export default {
  'menu.welcome': '首页',
  'menu.more-blocks': '更多区块',
  'menu.home': '首页',
  'menu.resource': '行业资源',
  'menu.users': '用户管理',
  'menu.projects': '项目管理',
  'menu.industry': '行业管理',

  'menu.industryList': '行业资讯库',
  'menu.industryList.industry': '行业资讯',
  'menu.industryList.industry-detail': '资讯详情',

  'menu.admin': '管理页',
  'menu.admin.sub-page': '二级管理页',
  'menu.all-notice': '全部通知',
  'menu.service': '投标管理',
  'menu.service.tender-preparation': '标书编制',


  'menu.service.projectAnalysis': '项目解析',
  'menu.service.formBidInfo': '手动填写标书信息',
  'menu.service.documentSetup': '标书设置',
  'menu.service.directoryGeneration': '目录生成',
  'menu.service.textGeneration': '正文生成',


  'menu.service.tender-manage': '投标管理',
  'menu.service.tender-manage.tender-manage-view': '查看报告',
  'menu.service.tender-manage.tender-manage-list': '报告列表',
  'menu.service.tender-manage.bidding-manage-list': '投标列表',
  'menu.service.tender-utils': '标书工具',
  'menu.knowledge': '企业知识库',
  'menu.knowledge.bidding-materials': '投标资料库',
  'menu.knowledge.reference-materials': '引用素材库',
  'menu.knowledge.image-library': '图片库',
  'menu.knowledge.enterprise-materials': '企业语料库',
  'menu.knowledge.styles': '样式库',
  'menu.login': '登录',
  'menu.register': '注册',
  'menu.register-result': '注册结果',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': '分析页',
  'menu.dashboard.monitor': '监控页',
  'menu.dashboard.workplace': '工作台',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': '表单页',
  'menu.form.basic-form': '基础表单',
  'menu.form.step-form': '分步表单',
  'menu.form.step-form.info': '分步表单（填写转账信息）',
  'menu.form.step-form.confirm': '分步表单（确认转账信息）',
  'menu.form.step-form.result': '分步表单（完成）',
  'menu.form.advanced-form': '高级表单',
  'menu.list': '列表页',
  'menu.list.table-list': '查询表格',
  'menu.list.basic-list': '标准列表',
  'menu.list.card-list': '卡片列表',
  'menu.list.search-list': '搜索列表',
  'menu.list.search-list.articles': '搜索列表（文章）',
  'menu.list.search-list.projects': '搜索列表（项目）',
  'menu.list.search-list.applications': '搜索列表（应用）',
  'menu.profile': '详情页',
  'menu.profile.basic': '基础详情页',
  'menu.profile.advanced': '高级详情页',
  'menu.result': '结果页',
  'menu.result.success': '成功页',
  'menu.result.fail': '失败页',
  'menu.exception': '异常页',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '触发错误',
  'menu.account': '个人页',
  'menu.account.center': '个人中心',
  'menu.account.settings': '个人设置',
  'menu.account.trigger': '触发报错',
  'menu.account.logout': '退出登录',
  'menu.editor': '图形编辑器',
  'menu.editor.flow': '流程编辑器',
  'menu.editor.mind': '脑图编辑器',
  'menu.editor.koni': '拓扑编辑器',
};
